import { useMemo } from 'react';
import { useToast } from '../context';
import { useLang } from '../i18n';
import { saveFailedNotifier } from '../data/errors';

/**
 * The `.catch` for a write made from a component: toasts why Firestore refused it (no
 * permission / deleted on another device / couldn't save — data/errors.js). Stable while
 * the language stays the same.
 */
export function useSaveFailed() {
  const notify = useToast();
  const { t } = useLang();
  return useMemo(() => saveFailedNotifier(notify, t), [notify, t]);
}
